import React from 'react';
import { CelestialShell } from './ui/CelestialShell';

export default function AuthLanding() {
  return (
    <CelestialShell>
      <main className="br-system-state">
        <div>
          <div className="br-system-state__mark" aria-hidden="true" />
          <p className="br-eyebrow">Secure connection</p>
          <h1>Opening your space</h1>
          <p>Your private session is being restored. This should only take a moment.</p>
        </div>
      </main>
    </CelestialShell>
  );
}
